import { Text, type TextProps } from '@mantine/core'

interface Props extends TextProps {
  idr: number | string | null | undefined
  fallback?: string
}

// `en-US` locale gives comma thousand separator (e.g. "3,465,000"), matching the
// Metarina visual. We prepend "Rp " manually so we don't rely on the locale's
// currency placement (Indonesian Rp is post-symbol with non-breaking space, etc.).
const numberFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

/**
 * Format IDR amount as "Rp 3,465,000". Input accepts number or decimal-string.
 */
export function CurrencyText({ idr, fallback = '-', ...rest }: Props) {
  return <Text {...rest}>{formatIdr(idr, fallback)}</Text>
}

export function formatIdr(idr: number | string | null | undefined, fallback = '-'): string {
  if (idr === null || idr === undefined) return fallback
  const n = typeof idr === 'string' ? Number(idr) : idr
  if (Number.isNaN(n)) return fallback
  return `Rp ${numberFormatter.format(n)}`
}
